<template src="../templates/ViewFile.html">

</template>

<script>

    import GetFileModel from "../models/GetFileModel";
    import pdf from 'vue-pdf'

    export default {
        name: "ViewFile",
        components: { pdf },

        data() {
          return {
            filename: null,
            ext: null,

            GetFileModel: new GetFileModel(),
            imageData: '',
            finalIImage: '',
            imageUrl: '',
          }
        },
        async mounted()  {
          this.filename = this.$route.query.filename;
          this.ext = this.$route.query.ext;
          let url =  this.$localApiURL + this.GetFileModel.getRoute('getFile') + '/'+this.filename+'/'+this.ext+'?token=' + localStorage.getItem("jwt");
          this.imageUrl = url;
        },
        methods:{
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ViewFile.vue